import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useQuery } from 'react-query';
import MeetingService from '../../services/MeetingService';
import FilledButton from '../../components/Buttons/FilledButton';
import classes from './styles.module.scss';

function useMeetingsByType(type, enabled) {
  return useQuery(
    ['library', type],
    async () => {
      try {
        return await MeetingService.getMeetings({
          page: 1,
          limit: 20,
          type,
          search: '',
          sortField: 'createdAt',
          sortOrder: 'DESC',
        });
      } catch (e) {
        return { rows: [] };
      }
    },
    { enabled }
  );
}

export default function ChooseFromLibraryModal({ show, initialTab = 'mobile uploads', onConfirm, onClose }) {
  const [tab, setTab] = useState(initialTab);
  const [selectedIds, setSelectedIds] = useState(new Set());

  useEffect(() => {
    if (show) {
      setTab(initialTab);
      setSelectedIds(new Set());
    }
  }, [show, initialTab]);

  const { data: mobileData } = useMeetingsByType('mobile uploads', show && tab === 'mobile uploads');
  const { data: savedData } = useMeetingsByType('saved', show && tab === 'saved');

  const rows = (tab === 'mobile uploads' ? mobileData?.rows || mobileData : savedData?.rows || savedData) || [];

  const getThumbUrl = (m) => m.signedThumbnailS3FileKey || m.thumbnail_url || m.thumbnailUrl || m.thumbnail || m.previewImage || m.preview_image || '';

  const toggleSelect = (id) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  };

  const handleConfirm = () => {
    const items = rows.filter((m) => selectedIds.has(m.id)).map((m) => ({
      id: m.id,
      title: m.title,
      duration: m.duration || 0,
      thumbnail_url: getThumbUrl(m),
      url: m.signedS3Url || m.signedVideoS3Url || m.videoUrl || '',
      projectRef: { meetingId: m.id },
      // Include s3FileKey to help determine if it's video or image-only content
      s3FileKey: m.s3FileKey,
    }));
    onConfirm(items);
  };

  const zoom =
    getComputedStyle(document.documentElement).getPropertyValue('--zoom').trim() || 0.9;

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      contentClassName={classes.ChooseFromLibraryModal}
      dialogClassName={classes.dialog}
      backdropClassName={classes.backdrop}
    >
      <div style={{ '--z': zoom }}>
        <header className={classes.header}>
          <h1 className={classes.title}>Import from Library</h1>
          <div className={classes.tabs}>
            <button type="button" className={tab === 'mobile uploads' ? classes.active : ''} onClick={() => setTab('mobile uploads')}>Mobile Uploads</button>
            <button type="button" className={tab === 'saved' ? classes.active : ''} onClick={() => setTab('saved')}>Saved Sections</button>
          </div>
        </header>
        <div className={classes.body}>
        <div className={classes.grid}>
          {rows.map((m) => {
            const inputId = `choose-lib-${m.id}`;
            return (
              <div key={m.id} className={classes.card}>
                <input id={inputId} type="checkbox" checked={selectedIds.has(m.id)} onChange={() => toggleSelect(m.id)} />
                <label htmlFor={inputId} className={classes.labelArea}>
                  <div className={classes.thumb}>
                    {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
                    <img src={getThumbUrl(m)} alt={`${m.title} thumbnail`} />
                  </div>
                  <div className={classes.meta}>
                    <div className={classes.title}>{m.title}</div>
                    <div className={classes.sub}>{m.duration ? `${Math.round(m.duration)}s` : ''}</div>
                  </div>
                </label>
              </div>
            );
          })}
          {!rows.length && <div className={classes.empty}>No items.</div>}
        </div>
        </div>
        <footer className={classes.footer}>
          <button type="button" className={classes.cancel} onClick={onClose}>Cancel</button>
          <FilledButton onClick={handleConfirm}>
            Import
          </FilledButton>
        </footer>
      </div>
    </Modal>
  );
}


